//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const FinancialAccount = {
    /** Gets the Event Registration Account Guid */
    EventRegistration: "2A6F9E5F-6859-44F1-AB0E-CE9CF6B08EE5",
    /**
     * Gets the General Fund Guid
     * Note:  Rock ships with the General Fund, but it could be deleted, so it isn't guaranteed to be there
     */
    GeneralFund: "4410306F-3FB5-4A57-9A80-09A3F9D40D0C",
};
